export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const START_LOADING = 'START_LOADING';
export const STOP_LOADING = 'STOP_LOADING';
export const SET_LANG = 'SET_LANG';